// extracted by mini-css-extract-plugin
export default {"wrapper":"FeedCardPdfCommon_wrapper__XJCaM"};